// Module
var code = "<svg fill=\"none\" stroke=\"currentColor\" width=\"100%\" height=\"100%\" viewBox=\"5 2 14 20\" xmlns=\"http://www.w3.org/2000/svg\"> <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M20 12H4\"></path> </svg>";
// Exports
module.exports = code;